import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { JobRepairBuilderSupervisorInterface } from '../interfaces/job-repair-builder-supervisor.interface';
import { JobRepairDto } from '../../job-repair/dto/job-repair.dto';
import { SubdivisionBuilderSupervisorDto } from '../../subdivision-builder-supervisor/dto/subdivision-builder-supervisor.dto';

@Exclude()
export class JobRepairBuilderSupervisorDto
  extends CommonEntityDto
  implements JobRepairBuilderSupervisorInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Repair ID',
  })
  @IsUUID()
  @Expose()
  jobRepairId!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Builder Supervisor ID',
  })
  @IsUUID()
  @Expose()
  subdivisionBuilderSupervisorId!: string;

  @ApiPropertyOptional({
    type: () => [JobRepairDto],
    title: 'Job Repair',
    description: 'The job repair associated with this builder supervisor',
  })
  @Expose()
  jobRepair?: JobRepairDto;

  @ApiPropertyOptional({
    type: () => [SubdivisionBuilderSupervisorDto],
    title: 'Builder Supervisor',
    description: 'The builder supervisor associated with this job repair',
  })
  @Expose()
  subdivisionBuilderSupervisor?: SubdivisionBuilderSupervisorDto;
}
